<script>
export default {
  props: {
    /**
     * @type {number} número de etapas ocultadas
     * @default 0
     */
    hiddenSteps: {
      type: Number,
      default: 0
    },
    /**
     * @type {Array<import('./business-card.vue').ParsedStep>} lista de etapas visiveis
     */
    visibleSteps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showDots() {
      return this.hiddenSteps > 0;
    },
    showNoData() {
      return this.hiddenSteps + this.visibleSteps.length <= 0;
    },
    /**
     * Mapa id -> valor exibido no stepper: posição (1-based) da etapa na
     * lista, que já chega na ordem do fluxo parametrizado. Os "sub-valores
     * ½" de etapas de ajuste (derivados do NOME) foram removidos — cada
     * etapa parametrizada ocupa a própria posição no fluxo.
     * @type {Object<string, string>}
     * @readonly
     */
    stepValues() {
      const map = {};

      this.visibleSteps.forEach((step, i) => {
        map[step.id] = String(i + 1);
      });

      return map;
    }
  }
};
</script>

<template>
  <div v-if="showNoData" class="no-data">
    Não existem dados para mostrar.
  </div>
  <v-stepper v-else horizontal>
    <v-stepper-header>
      <template
        v-for="({ completed, current, id, nome, name, repproved }, i) in visibleSteps"
      >
        <v-stepper-step
          v-if="showDots && !i"
          class="completed dots"
          :key="`step-${id}-${i}`"
          step="..."
        >
          +{{ hiddenSteps + 1 }} Etapas
        </v-stepper-step>
        <v-stepper-step
          v-else
          :class="{ completed, current, repproved }"
          :key="`step-${id}-${i}`"
          :step="stepValues[id] || '?'"
        >
          {{ nome || name }}
        </v-stepper-step>
        <v-divider :key="`divider-${id}-${i}`" class="timeline-trace" />
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<style lang="scss" scoped>
.no-data {
  width: 100%;
  text-align: center;
}

.v-stepper {
  box-shadow: none;
}

.v-stepper__header {
  align-items: flex-start;
  height: auto;

  .v-divider {
    align-self: unset;
    border-radius: 1rem;
    border-top: 0.25rem solid #d0d0d0;
    margin: 0.6rem -1.5rem 0;

    &:last-child {
      display: none;
    }
  }
}

.v-stepper__step {
  flex-direction: column;
  padding: 0 1.5rem;
  width: 8rem;

  &::v-deep {
    .v-stepper__step__step {
      margin: 0;
      background-color: #d0d0d0 !important;
      border-color: #d0d0d0 !important;
    }

    .v-stepper__label {
      color: #d0d0d0;
      text-align: center;
    }
  }

  &.completed {
    &::v-deep {
      .v-stepper__step__step {
        background-color: #6bb4ba !important;
        border-color: #6bb4ba !important;
      }

      .v-stepper__label {
        color: #6bb4ba;
      }
    }
  }

  &.current:not(.completed):not(.repproved)::v-deep {
    .v-stepper__step__step {
      background-color: #ffc440 !important;
      border-color: #ffc440 !important;
    }

    .v-stepper__label {
      color: #ffc440;
    }
  }

  &.current.repproved::v-deep {
    .v-stepper__step__step {
      background-color: #ff4040 !important;
      border-color: #ff4040 !important;
    }

    .v-stepper__label {
      color: #ff4040;
    }
  }
}

.completed + .v-divider.v-divider {
  border-top-color: #6bb4ba;
}

.dots::v-deep .v-stepper__step__step {
  font-size: 1.5rem;
  padding-bottom: 0.75rem;
}
</style>
